import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    userName: '',
    userType: 'student',
    roomId: '',
  });
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.userName || !formData.roomId) {
      alert('Please fill in all fields');
      return;
    }

    const route = formData.userType === 'staff' 
      ? `/staff/${formData.roomId}`
      : `/exam/${formData.roomId}`;
    
    navigate(route, { 
      state: { 
        userName: formData.userName,
        userType: formData.userType,
        roomId: formData.roomId
      }
    });
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Exam Proctoring System</h1>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              value={formData.userName}
              onChange={(e) => setFormData({ ...formData, userName: e.target.value })}
              placeholder="Enter your name"
              required
            />
          </div>
          <div className="form-group">
            <label>User Type</label>
            <select
              value={formData.userType}
              onChange={(e) => setFormData({ ...formData, userType: e.target.value })}
            >
              <option value="student">Student</option>
              <option value="staff">Staff/Proctor</option>
            </select>
          </div>
          <div className="form-group">
            <label>Room ID</label>
            <input
              type="text"
              value={formData.roomId}
              onChange={(e) => setFormData({ ...formData, roomId: e.target.value })}
              placeholder="Enter room ID"
              required
            />
          </div>
          <button type="submit" className="submit-btn">
            Join Room
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;






